import { Controller } from '@hotwired/stimulus'

const ACTIVE = ['bg-gray-900', 'text-white', 'border-gray-900']
const IDLE = ['bg-white', 'text-gray-600', 'border-gray-200', 'hover:border-gray-300']

export default class extends Controller {
  static targets = ['chip', 'card']

  select({ currentTarget, params: { folder } }) {
    const selected = String(folder)

    this.chipTargets.forEach((chip) => {
      const active = chip.contains(currentTarget)
      chip.classList.remove(...(active ? IDLE : ACTIVE))
      chip.classList.add(...(active ? ACTIVE : IDLE))
    })

    this.cardTargets.forEach((card) => {
      card.classList.toggle('hidden', selected !== 'all' && card.dataset.folder !== selected)
    })
  }

  openMenu({ currentTarget }) {
    const dropdown = currentTarget.closest('[data-controller~="dropdown"]')
    document.querySelectorAll('[data-controller~="template-folders"] [data-controller~="dropdown"]').forEach((other) => {
      if (other !== dropdown) this.application.getControllerForElementAndIdentifier(other, 'dropdown')?.close()
    })

    const menu = dropdown.querySelector('[data-dropdown-target="menu"]')
    menu.classList.replace('right-0', 'left-0')
    if (menu.getBoundingClientRect().right > document.documentElement.clientWidth - 16) {
      menu.classList.replace('left-0', 'right-0')
    }
  }
}
